import headers from "@/components/common/headers";
import navmenu from "@/components/common/navmenu";
import footers from "@/components/common/footers";
export default {
    name: 'Browse',
    components: { headers, navmenu, footers },
    data() {
        return {
            tabChoosed: 'BySpecies',
            letterList: ['All', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L',
                'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
            letterChoosed: 'All',
            speciestypeNum1: 0,
            speciestypeNum2: 0,
            speciestypeNum3: 0,
            showNum3: false,
            speciesData: {
                list: [],
                totalRow: 0
            },
            strainData: {
                list: [],
                totalRow: 0
            },
            queryParams: {
                pagesize: 10,
                pagenum: 1,
                type: '1'
            },
            showSpeciesType: true,
            showStandardType: true,
            showLetterList: true,
            standardTableData: {
                list: [],
                totalRow: 0
            },
            collectionTableData: {
                list: [],
                totalRow: 0
            },
            standardQueryParams: {
                pagesize: 10,
                pagenum: 1,
                group: 'All',
                type: 'standard',
            },
        }
    },
    mounted() {
        if (this.$route.path) {
            if (this.$route.path == '/browse/species') {
                this.tabChoosed = 'BySpecies'
                this.getList(1, this.tabChoosed)
            } else if (this.$route.path == '/browse/strain') {
                this.tabChoosed = 'ByWDCMNumber'
                this.getList(1, this.tabChoosed)
            } else if (this.$route.path == '/browse/collectionid') {
                this.tabChoosed = 'ByCultureCollection'
                this.getTableList()
            } else if (this.$route.path == '/browse/standard') {
                this.tabChoosed = 'ByStandardMethod'
                this.getTableList()
            }
        }
    },
    methods: {
        tabsClick(val) {
            this.tabChoosed = val
            this.speciestypeNum1 = 0
            this.speciestypeNum2 = 0
            this.speciestypeNum3 = 0
            this.letterChoosed = 'All'
            this.showNum3 = false
            if (val == 'BySpecies') {
                this.$router.push({
                    path: '/browse/species'
                })
                this.showSpeciesType = true
                this.showLetterList = true
                this.showStandardType = false
                this.queryParams.type = '1'
                this.getList(1, val)
            } else if (val == 'ByWDCMNumber') {
                this.$router.push({
                    path: '/browse/strain'
                })
                this.showSpeciesType = false
                this.showLetterList = false
                this.showStandardType = false
                // 置空搜索字母及type参数
                this.getList(1, val)
            } else if (val == 'ByCultureCollection') {
                this.$router.push({
                    path: '/browse/collectionid'
                })
                this.showSpeciesType = false
                this.showLetterList = true
                this.showStandardType = false
                // 置空搜索type参数
                this.getTableList()
            } else if (val == 'ByStandardMethod') {
                this.$router.push({
                    path: '/browse/standard'
                })
                this.standardQueryParams = {
                    pagesize: 10,
                    pagenum: 1,
                    group: 'All',
                    type: 'standard',
                }
                this.showSpeciesType = false
                this.showLetterList = true
                this.showStandardType = true
                this.getTableList()
            }

        },
        letterClick(val) {
            this.letterChoosed = val
            this.showSpeciesType = false
            this.showStandardType = false
            if (this.tabChoosed == 'BySpecies' ) {
                this.queryParams.type = 0
                this.showNum3 = true
                this.getSpecies()
            } else if (this.tabChoosed == 'ByCultureCollection' ) {
                this.getCollection()
            } else if (this.tabChoosed == 'ByStandardMethod') {
                this.standardQueryParams.group = val
                this.standardQueryParams.type = 'all'
                this.getStandardList()
            }
        },
        getList(val) {
            if (this.tabChoosed == 'BySpecies' ) {
                this.getSpecies(val)
            } else if (this.tabChoosed == 'ByWDCMNumber') {
                this.getStrain(val, { pagesize: 10,pagenum: 1,})
            }
        },
        getSpecies(val) {
            this.queryParams.pagenum = val ? val : 1
            let params = {
                group: this.letterChoosed,
                pagenum: val ? val : 1,
                pagesize: 10,
                type: this.queryParams.type// 0/1/2
            }
            this.Ajax(API.browse.species, params, 'get', true).then(res => {
                this.speciesData.list = res.list
                this.speciesData.totalRow = res.totalRow
                this.speciestypeNum1 = res.totalRow
                this.speciestypeNum2 = res.straintotal
                if (this.showNum3) {
                    this.speciestypeNum1 = 0
                    this.speciestypeNum2 = 0
                    this.speciestypeNum3 = res.totalRow
                }
            }).catch(err => {
                console.log(err)
            })
        },
        getStrain(pagenum,params) {
            params.pagenum=pagenum?pagenum:1
            this.Ajax(API.browse.strain, params, 'get', true).then(res => {
                this.strainData.list = res.list
                this.strainData.totalRow = res.totalRow
                this.speciestypeNum3 = res.totalRow
            }).catch(err => {
                console.log(err)
            })
        },
        getTableList(val) {
            if (this.tabChoosed == 'ByCultureCollection' ) {
                this.getCollection(val)
            } else if (this.tabChoosed == 'ByStandardMethod') {
                this.getStandardList(val)
            }
        },
        getCollection(val) {
            let params = {
                pagesize: 10,
                pagenum: val?val:1,
                group: this.letterChoosed || 'all',
            }
            this.Ajax(API.browse.searchcollection, params, 'get', true).then(res => {
                if (res) {
                    this.collectionTableData.list = []
                    if (res.list && res.list.length > 0) {
                        res.list.forEach(item => {
                            
                            if(item.ref && item.ref.length > 0) {
                                item.ref.forEach(item2 => {
                                    let obj = {
                                        "xrefcc_id": item.xrefcc_id,
                                        "strain_id": item2.strain_id,
                                        "firstname": item2.firstname,
                                        "middlename": item2.middlename,
                                        "lastname": item2.lastname,
                                        "othersname": item2.othersname,
                                    }
                                    this.collectionTableData.list.push(obj)
                                })
                            }
                        })
                    }
                    this.collectionTableData.totalRow = res.totalRow
                    this.speciestypeNum3 = res.totalRow
                }
                
            }).catch(err => {
                console.log(err)
            })
        },
        getStandardList(val) {
            this.standardQueryParams.pagenum = val ? val : 1
            this.Ajax(API.browse.standard, this.standardQueryParams, 'get', true).then(res => {
                this.standardTableData.list = res.list
                this.standardTableData.totalRow = res.totalRow
                this.speciestypeNum3 = res.totalRow
            }).catch(err => {
                console.log(err)
            })
        },
        reset() {
            this.speciestypeNum1 = 0
            this.speciestypeNum2 = 0
            this.speciestypeNum3 = 0
            this.speciesData = {
                list: [],
                totalRow: 0
            }
            this.strainData = {
                list: [],
                totalRow: 0
            }
            this.queryParams = {
                pagesize: 10,
                pagenum: 1,
                type: '1'
            }
            this.standardTableData = {
                list: [],
                totalRow: 0
            }
            this.collectionTableData = {
                list: [],
                totalRow: 0
            }
            this.standardQueryParams = {
                pagesize: 10,
                pagenum: 1,
                group: this.letterChoosed|| 'all',
                type: 'standard',
            }
        },
        gotoDetail(id, from) {
            this.$router.push({
                path: '/browse/getinfo',
                query: {
                    sid: id,
                    from: from
                }
            })
        },

    }
}


// WEBPACK FOOTER //
// ./src/views/browse/index.js